/**
 * Utility function to determine the correct label for previous notes based on note type
 * @param note - Note object with addressNoteId and noteType properties
 * @returns The appropriate label string for previous notes
 */
export const getPreviousNotesLabel = (note: {
  addressNoteId: number | null;
  noteType: string;
}): string => {
  if (note.addressNoteId != null) {
    return 'PREVIOUS ADDRESS NOTES';
  }

  if (note.noteType === 'internal') {
    return 'PREVIOUS INTERNAL NOTES';
  }

  return 'PREVIOUS DRIVER NOTES';
};

